import React from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const ModalButton = ({ onClick, label = "Ajouter" }) => (
  <Button
    variant="contained"
    color="primary"
    startIcon={<AddIcon />}
    onClick={onClick}
    sx={{ height: '40px' }}
  >
    {label}
  </Button>
);

export default ModalButton;
